module.exports = __webpack_public_path__ + "img/tastytrade.2981790a.png";